import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import backgroundImg from "./images/x-h4.jpg";

interface CardCarouselProps {
  cards: Array<{ title: string; text: string; imageUrl: string }>;
  width: number;
}

const CardCarousel: React.FC<CardCarouselProps> = ({ cards, width }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showOnlyMiddle, setShowOnlyMiddle] = useState(width < 992);

  useEffect(() => {
    setShowOnlyMiddle(width < 992);
  }, [width]);

  const calculateIndex = (index: number) => (index + cards.length) % cards.length;

  const colStyle = (isMiddle: boolean): React.CSSProperties => ({
    position: "relative",
    textAlign: "center",
    background: isMiddle ? `url(${backgroundImg})` : "transparent",
    backgroundSize: isMiddle ? "cover" : "",
    backgroundPosition: isMiddle ? "center center" : "",
    backgroundRepeat: isMiddle ? "no-repeat" : "",
    border: isMiddle ? "2px solid #c39d63" : "none",
    borderRadius: "8px",
    padding: "50px",
    cursor: "pointer",
    transition: "background-color 0.3s ease-in-out",
    boxShadow: isMiddle ? "0px 4px 10px rgba(0, 0, 0, 0.2)" : "none",
    display: showOnlyMiddle && !isMiddle ? "none" : "block",
  });

  const imageStyle: React.CSSProperties = {
    width: "100%",
    borderRadius: "8px",
    marginBottom: "1rem",
  };

  const subTitleStyle: React.CSSProperties = {
    fontSize: "44px",
    fontWeight: 300,
    marginBottom: 75,
    color: "#514633",
    textTransform: "capitalize",
    fontFamily: "Avenir Next Condensed Ultralight",
    fontStyle: "normal",
    lineHeight: "33px",
    letterSpacing: ".03em",
    display: "block",
  };

  const contentStyle: React.CSSProperties = {
    fontFamily: "Avenir Next Condensed Regular",
    fontWeight: 300,
    fontSize: "20px",
    lineHeight: "24px",
    textTransform: "capitalize",
    color: "#342714",
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) => calculateIndex(prevIndex + 1));
  };

  const handlePrev = () => {
    setCurrentIndex((prevIndex) => calculateIndex(prevIndex - 1));
  };

  const visibleCards = [
    cards[calculateIndex(currentIndex - 1)],
    cards[calculateIndex(currentIndex)],
    cards[calculateIndex(currentIndex + 1)],
  ];

  return (
    <Container>
      <Row>
        {visibleCards.map((card, index) => (
          <Col
            key={index}
            xs={12}
            sm={12}
            md={12}
            lg={4}
            xl={4}
            style={colStyle(index === 1)}
            onMouseEnter={(e) =>
              index !== 1 && (e.currentTarget.style.backgroundColor = "white")
            }
            onMouseLeave={(e) =>
              index !== 1 && (e.currentTarget.style.backgroundColor = "transparent")
            }
          >
            <div style={{ minHeight: "100%", padding: 22, background: "#fff" }}>
              <img src={card.imageUrl} alt={card.title} style={imageStyle} />
              <div>
                <h5 style={subTitleStyle}>{card.title}</h5>
                <p style={contentStyle}>{card.text}</p>
              </div>
            </div>
          </Col>
        ))}
      </Row>

      <div style={{ display: "flex", justifyContent: "center", marginTop: "1rem" }}>
        <button onClick={handlePrev} style={{ marginRight: "0.5rem" }}>
          Previous
        </button>
        <button onClick={handleNext}>Next</button>
      </div>
    </Container>
  );
};

export default CardCarousel;
